import { CourseDetails } from '@lx/quote-tool/lite/shared/types';

/**
 * Type for displaying courses in a tree structure
 */
export interface CourseTreeNode {
  key?: string;
  label?: string;
  subLabel?: string;
  courseDetails?: CourseDetails;
  type?: string; //Type of the node to match a template. Handled values are 'parent' or 'child'.
  expanded?: boolean;
  children?: CourseTreeNode[];
  parent?: CourseTreeNode;
  weight?: number;
}

export enum CourseTreeNodeType {
  courseType = 'courseType',
  course = 'course',
}
